const einrichtungKlient_de = {
  transportationModel: {
    transportationModelReadOnly:
      'Standardwoche kann nicht verändert werden, da es bereits Klient:innen zugewiesen wurde.',
    transportationModelReadOnlyHint:
      'Standardwochen dienen als Vorlage für die Erstellung von Kalendereinträgen für Klient:innen. Da sie flexibel in verschiedenen Zeiträumen (Vergangenheit oder Zukunft) angewendet werden können, würde eine nachträgliche Änderung bereits verknüpfter Standardwochen zu unerwarteten Ergebnissen führen. Bitte erstellen Sie stattdessen ein neue Standardwoche.',
    studentListTooltip: 'Klient:innen mit dieser Standardwoche am ausgewählten Datum',
    students: 'Klient:innen',
    errorStudentCalendarEventsExist:
      'Fehler beim Update der Standardwoche, da das Model bereits mit Klient:innen verknüpft ist.',
    deleteErrorMessageSingular:
      'Die Standardwoche konnte aufgrund bestehender Verknüpfungen mit Klienten nicht gelöscht werden.',
    validation: {
      unknownType: '{{day}} - {{hour}}: Unbekannter Einrichtungs-Stunden-Ortstyp: {{type}}',
    },
  },
  transportationPeriod: {
    helpInfoText:
      'Die Beförderungsperiode filtert die Klient:innen anhand der Angaben in den Feldern „Beförderung ab“ und „Beförderung bis“. ',
  },
  addStudentsToExtraTourDialog: {
    popUpOpenTitle: 'Hinzufügen mehrerer Klient:innen zu einer ausgewählten Extratour',
    secondStepInfo: 'Bitte wählen sie einen Ort für die ausgewählten Klient:innen aus: ',
    thirdStep: 'Klient:innen zur ausgewählten Extratour hinzufügen',
    thirdStepInfo:
      'Um Klient:innen hinzuzufügen, wählen sie bitte eine der nachfolgenden Extratouren aus: ',
  },
  student: {
    singular: 'Klient:in',
    plural: 'Klient:innen',
    gender_MALE: 'Klient',
    gender_FEMALE: 'Klientin',
    gender_DIVERS: 'Klient:in',
    new: 'neue Klient:in',
    remove: 'Klient entfernen',
    changingDefaultTransportationPlaceHint:
      'Geänderter Beförderungspunkt wird ab {{date}} in Kalenderevents eingetragen und Klient:in aus allen Touren entfernt.',
    changingDefaultTransportationPlaceHintPlural:
      'Geänderter Beförderungspunkt wird ab {{date}} in Kalenderevents der Klient:innen eingetragen und diese aus allen Touren entfernt.',
    detail: 'Klient',
    school_select: 'Auswahl aller Klient:innen der Standardwoche: ',
    school_select_helper:
      'Selektieren Sie alle Klient:innen dieser Standardwoche und speichern Sie',
    studentsOfTransportationModelId: 'Klient:innen der Standardwoche mit der ID: ',
    studentsOfSchoolId: 'Klient:innen der Einrichtung mit der ID: ',
    studentsWithTransportationNeed: 'Klient:innen mit Beförderungsbedarf',
    studentsFromTourSchoolId: 'Klient:innen der Tour mit der ID: ',
    studentsFromSelectedTours: 'Klient:innen der ausgewählten Touren',
    changes: {
      noSchoolSelected: 'keine Einrichtung',
      editTransportationModelInList: 'Kann in der Klient:innenliste bearbeitet werden',
    },
    changingSchoolHint:
      'Klient:in wird ab {{date}} aus allen Touren entfernt und muss neu eingeplant werden',
    list: 'Liste aller Klient:innen',
    add_tour: 'Klient:innen zur Tour hinzufügen',
    add: 'Klient:in hinzufügen',
    employeeNumber: 'Klient:innen Nummer',
    schoolClass: 'Gruppe',
    tour_list: 'Touren der Klient:innen',
    tourPlan_list: 'Planungen der Klient:innen',
    deleteStudentSingular: 'Möchten Sie diese Klient:in löschen?',
    deleteStudentPlural: 'Möchten Sie diese Klient:innen löschen?',
    deleteErrorHintSingular:
      'Sollten keine Touren in der Zukunft bestehen, dann wird die Klient:in ab morgigen Datum nicht mehr angezeigt.',
    deleteErrorHintPlural:
      'Sollten keine Touren in der Zukunft bestehen, dann werden die Klient:innen ab morgigen Datum nicht mehr angezeigt',
    deleteStudentFailedSingular: 'Löschen fehlgeschlagen, da Klient:in verplant',
    deleteStudentFailedPlural:
      'Löschen für folgende Klient:innen fehlgeschlagen, da diese verplant sind: ',
    deleteErrorSingular: 'Fehler beim Löschen einer Klient:in',
    deleteErrorPlural: 'Fehler beim Löschen der Klient:innnen',
    updateError: 'Fehler beim Aktualisieren der Klient:in',
    updateDateMustBeMonday:
      'Bei Anpassung der Einrichtung muss das Änderungsdatum ein Montag sein.',
    tour: {
      tours_of_selected_student: 'Anzeige für gewählte Klient:innen',
      select_students_from_geocoded:
        'Die Tourenplanung konnte für die aktuell ausgewählten Klient:innen nicht gestartet werden, da folgende Klient:innen nicht eindeutig geokodiert sind:',
    },
    goToSchoolDetail: 'zur gewählten Einrichtung',
    dateMustBeMonday:
      'Das "gültig ab" Datum muss auf einen Montag gesetzt werden, wenn die Standardwoche oder die Einrichtung angepasst wird',
  }, // end student
  studentApplication: {
    title: 'Klient:innen Anträge',
    detail: 'Klient:in Antrag',
    schoolClass: 'Gruppe',
    school: 'Einrichtung',
    applicationForCurrentTransportationPeriod: 'Antrag für diese Beförderungsperiode',
    applicationForNextTransportationPeriod: 'Antrag für die nächste Beförderungsperiode',
    studentAddress: 'Adresse Klient:in',
    comparison: {
      studentApplicationAttributes: 'Klient:in Attribute aus Antrag',
      studentAttributes: 'Klient:in Attribute im System',
      NO_MATCH: 'Es wurde kein Duplikat einer Klient:in gefunden',
      SINGLE_MATCH: 'Es wurde ein Duplikat einer Klient:in gefunden',
      MULTIPLE_MATCHES:
        'Es wurden mehrere Übereinstimmungen gefunden. Bitte überprüfen Sie die angezeigten Klient:innen.',
    },
    stepper: {
      chooseAttributes:
        'Bitte wählen Sie ein Attribut aus der jeweiligen Liste des Antrags oder der Klient:in aus:',
      chooseAttributesWithoutDuplicate:
        'Bitte wählen Sie die Attribute für die Neuanlage einer Klient:in aus:',
      error: 'Es ist ein Fehler beim Laden der Klient:innen aufgetreten.',
      noDuplicateFound:
        'Es wurde kein Duplikat festgestellt. Sie können nun einen neuen Klient über die folgenden Schritte anlegen',
      createNewStudent: 'Möchten Sie einen neuen Klient aus dem Antrag erstellen?',
      geocodeInfo:
        'Sie können die angegebene Adresse geokodieren. Ist die Klient:in mit dem bisherigen Haltepunkt ' +
        'bereits in Touren verplant, wird ein zusätzlicher Haltepunkt bei der Klient:in hinterlegt. Bei nicht eindeutiger Geokodierung ' +
        'wird kein Haltepunkt angelegt.',
      finalApprovalInfo:
        'Bei der Übernahme des Antrags wird ggf. eine Klient:in im System aktualisiert bzw. neu angelegt. Die Änderung sind gültig ab dem ' +
        'von Ihnen ausgewählten Datum. Der Antrag wird nach der Übernahme als bearbeitet markiert.',
    },
  },
  school: {
    singular: 'Einrichtung',
    plural: 'Einrichtungen',
    new: 'neue Einrichtung',
    deleteSchoolSingular:
      'Möchten Sie diese Einrichtung sowie verknüpfte Klient:innen und Touren wirklich löschen?',
    minutesBeforeSchoolHour: 'Min. vor Start/nach Ende',
    config: 'Einrichtungs-Konfiguration',
    schoolAuthority: 'Träger',
    schoolDeletionEntities: {
      studentIdsOneSchool: 'Anzahl der Klient:innen mit einer Einrichtung: ',
      studentIdsTwoOrMoreSchool: 'Anzahl der Klient:innen mit mehr als einer Einrichtung: ',
      amountStudents: 'Anzahl der Klient:innen: ',
      infoText:
        'Bitte beachten Sie, dass alle Touren mit der ausgewählten Einrichtung gelöscht werden. Klient:innen mit mehr als einer Einrichtung werden nicht gelöscht. ',
    },
    tour: {
      tours: 'Touren der Einrichtung',
      tours_planned: 'Planungen der Einrichtung',
      tours_of_selected_school: 'Anzeige für gewählte Einrichtungen',
    },
    student: {
      students: 'Klienten der Einrichtung',
    },
  },
  schoolcenter: {
    singular: 'Zentrum',
    plural: 'Zentren',
    new: 'neues Zentrum',
  },
  tours: {
    amountOfStudentsInTour: 'Anzahl der Klient:innen',
    studentNamesOfTour: 'Klient:innen der Tour',
    studentNamesOfSelectedTours: 'Klient:innen der ausgewählten Touren',
    totalStudents: 'Gesamtzahl der Klient:innen',
    minutesAroundSchool: 'Minuten vor Start/nach Ende',
    minutesAroundSchoolTOTour: 'Ankunft Minuten vor Start',
    minutesAroundSchoolFROMTour: 'Abfahrt Minuten nach Ende',
    tender: {
      headerContentSchoolName: 'Einrichtungen',
      tourServiceContentSchools: 'Adresse(n) der Einrichtung(en)',
      stopsListSchoolClass: 'Gruppe der Klient:in',
      showStudentSchoolClass: 'Gruppe anzeigen',
      headerBidderSchools: 'Name der Einrichtung(en)(automatische Anzeige)',
    },
    errorNotification: {
      base: 'Fehler beim Anlegen von Touren. ',
      base_change: 'Fehler beim Ändern einer Tour',
      no_tours_planned: 'Es wurden keine Touren geplant.',
      no_transportationModel: 'Die betroffenen Klienten haben keine Standardwoche.',
      no_weekday_with_demand: 'An keinem der ausgewählten Wochentage besteht Beförderungsbedarf.',
      tour_loading_error:
        'Fehler beim Laden der Tour: Das gewählte Datum liegt nicht im Gültigkeitszeitraum der Tour.',
      status: {
        'Internal Server Error': 'Ein interner Server-Fehler ist aufgetreten.',
        ALREADY_IN_TOUR: 'Die Klient:in ist bereits dieser Tour zugewiesen.',
        STUDENT_ALREADY_IN_TOUR: 'Die Klient:in ist bereits einer Tour zugewiesen.',
        LAST_STUDENT_IN_TOUR: 'Die Tour enthält nur noch diese Klient:in.',
        INSUFFICIENT_REGULAR_SEATS:
          'Das Fahrzeug hat nicht genügend reguläre Sitzplätze für die Klient:in und eventuell ' +
          'erforderliche Begleitpersonen.',
        INSUFFICIENT_WHEELCHAIR_SEATS:
          'Das Fahrzeug hat nicht genügend Rollstuhlplätze für die Klient:in.',
        MISSING_CALENDAR_EVENTS:
          'Die Klient:in hat an mindestens einem Tourtag keine Kalendereinträge.',
        INCOMPATIBLE_SCHEDULE:
          'Die Beförderungszeiten der Events im Kalender der Klient:in sind nicht mit den ' +
          'Beförderungszeiten der Tour kompatibel.',
        NO_SEATS_AVAILABLE:
          'Es sind keine freien Plätze im Fahrzeug verfügbar. Bitte überprüfen Sie auch die Anzahl der freien Rollstuhlplätze.',
        MAX_TIME_IN_VEHICLE_CONSTRAINT:
          'Sie können die Klient:in nicht hinzufügen, da sonst die maximale ' +
          'Beförderungszeit überschritten wird. Hinweis: Sie können die maximale ' +
          'Beförderungszeit in der Einrichtungsverwaltung bearbeiten und die Klient:in ' +
          'anschließend in die Tour eintragen.',
        SCHEDULE_NOT_SUITABLE:
          'Bitte überprüfen Sie den Kalender der Klient:in. Für mindestens einen Tourtag wurden keine passenden Kalendereinträge gefunden.',
        STUDENT_DOES_NOT_FIT:
          'Die Klient:in kann aufgrund der Fahrzeugkapazität, des Tourtyps, der Gruppierung ' +
          'oder der angegebenen Beförderungszeiten nicht hinzugefügt werden.',
        NO_SCHEDULE:
          'Bitte überprüfen Sie den Kalender der Klient:in. Es konnten keine Events ' +
          'zum Zeitpunkt der Änderung gefunden werden.',
      },
      overlappingToursInfo:
        'Klient:in {{studentId}} ist bereits {{count}} Tour(en) am {{date}} zugewiesen:',
      viewTour: 'Tour anzeigen',
      details: {
        studentId: {
          singular: 'Klient:in-ID',
          plural: 'Klient:innen-IDs',
        },
      },
    },
    add_student: 'Klient:in hinzufügen',
    addStudentFiltered:
      'Klient:innen hinzufügen (Gefilterte Liste: Es werden nur passende Klient:innen angezeigt)',
    addStudentWithPlaceInfo:
      'Der ausgewählte Ort wird beim Klient als Abhol- bzw. Abfahrtsort in der Extratour hinterlegt und die Tour wird neu berechnet.',
    tourInMap: {
      allStudents: 'alle Klient:innen',
      allSchools: 'alle Einrichtungen',
    },
    plan: {
      fromTransportationPlace: 'Ziel ist Einrichtung',
      algorithmGroupPriority: 'Klient-Gruppen zusammenhalten',
    },
    students_do_boarding: 'Klient:innen steigen hier ein',
    students_do_disembarking: 'Klient:innen steigen hier aus',
    students_unassigned: 'Klient:innen konnten nicht eingeplant werden',
    unassignedType: {
      MAX_TIME_IN_VEHICLE_CONSTRAINT:
        'Sie können den Fahrgast nicht hinzufügen, da sonst die' +
        ' maximale Beförderungszeit überschritten wird.' +
        'Hinweis: Sie können in der Einrichtungs-Verwaltung die maximale Beförderungszeit editieren ' +
        'und anschließend den Fahrgast in die Tour eintragen. ',
    },
    tourDetail: {
      studentCount: 'Anzahl Klient:innen', //line 877
      time: {
        timeBeforeSchoolStart: 'Ankunft vor Beginn',
        timeAfterSchoolEnd: 'Abfahrt nach Ende',
      },
    },
  },
  exportPage: {
    tours: {
      label: 'Auswahl Einrichtungen und Touren',
      schools: 'Einrichtungen',
    },
  },
  importTypeTitle: {
    STUDENTS: 'Klient',
  },
  excelImport: {
    typesSuccess: {
      STUDENTS: 'Klient-Excel importiert',
    },
    conflictResolution: {
      question: 'Sollen folgende Klient:innen überschrieben werden?',
      description:
        'Wählen Sie „Ja“, um die bestehende Klient:in mit den importierten Daten ' +
        'zu überschreiben. Wählen Sie „Nein“, um die bestehende Schüler:in unverändert zu' +
        ' lassen und diese Excel-Zeile nicht zu importieren. Bei Bestätigung wird das Excel-File' +
        ' mit Berücksichtigung der Konflikte importiert.',
    },
    typesError: {
      STUDENTS: 'Klient-Excel Fehler',
    },
    attributes: {
      SCHOOL_CLASS: 'Gruppe',
    },
  },
  contextMenu: {
    tour: {
      minutesAroundSchool: 'Minuten vor Start/nach Ende',
    },
    student: {
      assignTransportationModelHint:
        'Die Änderungsmöglicheiten sind bewusst begrenzt, um unvorhergesehene Änderungen in der Vergangenheit zu vermeiden.\n\nKlient:innen ohne Touren: Änderung jederzeit möglich.\nKlient:innen mit Touren: Änderung nur ab dem heutigen Datum möglich (Klient:innen werden ab dem "gültig ab" Datum aus allen(!) Touren entfernt).',
      assignTransportationModelHintTwo:
        'Die Standardwoche ist eine Schablone, mit der Kalendereinträge für Klient:innen erstellt werden können.\n\nDie Standardwoche wird für den gewählten Zeitraum gesetzt und die Kalendereinträge entsprechend erstellt. Zuvor werden alle durch Standardwochen gesetzten Kalendereinträge ab dem "gültig ab" Datum gelöscht. Manuell erstellte Kalendereinträge bleiben erhalten.',
      differentSchools: 'Bitte nur Klient:inner einer Einrichtung auswählen',
      errorStudentInPastTour: 'Klient:in in vergangenen Touren',
      errorStudentInDifferentSchool: 'Klient:in in unterschiedlichen Einrichtungen',
      autoAssignPublicTransportationPlaceInfo:
        'Hiermit wird den ausgewählten Klient:innen automatisch der nächstgelegene ÖPNV-Haltestelle' +
        ' per Luftlinie zugewiesen.',
    },
  },
  tourWizard: {
    followingToursWereChanged:
      'Die folgenden Touren wurden nach der Herausnahme der ' +
      'Klient:in bzw. der Anpassung des Events neu erstellt oder geändert:',
  },
  transportationNeedCheck: {
    infoTitle: 'Übersicht des Beförderungsbedarfs ausgewählter Klient:innen',
    studentsWithUnfulfilledTransportationNeed:
      'Anzahl der Klient:innen mit nicht gedecktem Beförderungsbedarf:',
    amountOfCheckedStudentsInfo: 'Anzahl der überpüften Klient:innen:',
  },
  globalMap: {
    filterBySchoolTransportationTime: 'Touren und Klient:innen filtern',
    filterBySchoolTransportationTimeTooltip:
      'Touren werden nach allen gewählten Attributen gefiltert. Klient:innen werden aufgrund der gewählten Einrichtung gefiltert.',
    selectedSchools: 'Ausgewählte Einrichtungen',
    removeSchool: 'Einrichtung löschen',
  },
  placeType: {
    HOME: 'Klient:in Haltepunkt',
    SCHOOL: 'Einrichtung',
    SCHOOLCENTER: 'Zentrum',
  },
  placeManagement: {
    deleteError:
      'Löschen fehlgeschlagen, da Haltepunkt noch im System verwendet wird (Bsp: Klient:in, Einrichtung, Tour, Event, ...)',
  },
  tourPlanningWizard: {
    matrixHeaders: {
      student: 'Klient:in',
    },
  },
  timelineGroup: {
    students: 'Klienten',
  },
};

export default einrichtungKlient_de;
